module.exports = __webpack_public_path__ + "img/fm-whatsapp-install.a6a4e694.webp";